app.mediator.registerModule(MODULE_NAME__HOME_PAGE, function (app) {

    var helpers = app.helpers.funcs;

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            this.$rootElem = $('.mod-page-home');
            if (!this.$rootElem.length) return;
            this.addDomListeners();
            this.addMediatorListeners();
            this.adjustPrizeColumnHeights();
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addDomListeners: function() {
            var scope = this;
            this.$rootElem.find('.social-share-button').click(function () {
                app.mediator.notify(EVENT_NAME__HOME_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED);
            });

            app.globalEventRegistry.addListener('resize', function () {
                scope.adjustPrizeColumnHeights();
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {
            var scope = this;

            // In the situation that the main nav has just closed in response to
            // the viewport being resized to become greater than a mobile width,
            // the resize event will not be enough to re-establish aspect ratios.
            // Therefore, re-establish aspect ratios in response to the main nav
            // close event.
            app.mediator.addListener(EVENT_NAME__MAIN_NAV__CLOSED, function () {
                setTimeout(function () {
                    scope.adjustPrizeColumnHeights();
                }, 500);
            });
        },
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

        adjustPrizeColumnHeights: function () {
            var $prizesRow = this.$rootElem.find('.prize-items');
            helpers.equaliseColumnHeightsInRow($prizesRow, '> div .inner');
        }

	};
});
